import { isOverrideableDocFilterTypeId, SortTypeIds } from "../models/stores/ui-types";
/**
 * Maps sort type IDs (used in PrimarySortType) to translation keys.
 * Most sort types use their ID as the key, but some have namespaced keys
 * to avoid collisions with other uses of the same term.
 */
export const SORT_TYPE_TO_TRANSLATION_KEY = {
    Group: "studentGroup",
    Name: "sortLabel.sortByOwner",
    Date: "sortLabel.sortByDate",
    Strategy: "strategy",
    Bookmarked: "bookmarked",
    Tools: "tools",
    Problem: "contentLevel.problem"
};
/**
 * Get the translation key for a sort type ID.
 */
export function getSortTypeTranslationKey(sortType) {
    var _a;
    return (_a = SORT_TYPE_TO_TRANSLATION_KEY[sortType]) !== null && _a !== void 0 ? _a : sortType;
}
export const FILTER_TYPE_TO_TRANSLATION_KEY = {
    Problem: "contentLevel.problem",
    Investigation: "contentLevel.investigation",
    Unit: "contentLevel.unit"
};
export function getFilterTypeTranslationKey(filterType) {
    return isOverrideableDocFilterTypeId(filterType)
        ? FILTER_TYPE_TO_TRANSLATION_KEY[filterType]
        : filterType;
}
export function isValidSortTypeId(value) {
    return SortTypeIds.includes(value);
}
/**
 * Escape a translation key for use with React Hook Form.
 * RHF interprets dots as nested object paths, so we convert dots to underscores.
 */
export function escapeKeyForForm(key) {
    return key.replace(/\./g, "_");
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic29ydC11dGlscy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy91dGlsaXRpZXMvc29ydC11dGlscy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQ1UsNkJBQTZCLEVBQTJDLFdBQVcsRUFDbkcsTUFBTSwyQkFBMkIsQ0FBQztBQUduQzs7OztHQUlHO0FBQ0gsTUFBTSxDQUFDLE1BQU0sNEJBQTRCLEdBQTJDO0lBQ2xGLEtBQUssRUFBRSxjQUFjO0lBQ3JCLElBQUksRUFBRSx1QkFBdUI7SUFDN0IsSUFBSSxFQUFFLHNCQUFzQjtJQUM1QixRQUFRLEVBQUUsVUFBVTtJQUNwQixVQUFVLEVBQUUsWUFBWTtJQUN4QixLQUFLLEVBQUUsT0FBTztJQUNkLE9BQU8sRUFBRSxzQkFBc0I7Q0FDaEMsQ0FBQztBQUVGOztHQUVHO0FBQ0gsTUFBTSxVQUFVLHlCQUF5QixDQUFDLFFBQW9COztJQUM1RCxPQUFPLE1BQUEsNEJBQTRCLENBQUMsUUFBUSxDQUFDLG1DQUFJLFFBQThCLENBQUM7QUFDbEYsQ0FBQztBQUVELE1BQU0sQ0FBQyxNQUFNLDhCQUE4QixHQUE0RDtJQUNyRyxPQUFPLEVBQUUsc0JBQXNCO0lBQy9CLGFBQWEsRUFBRSw0QkFBNEI7SUFDM0MsSUFBSSxFQUFFLG1CQUFtQjtDQUMxQixDQUFDO0FBRUYsTUFBTSxVQUFVLDJCQUEyQixDQUFDLFVBQXlCO0lBQ25FLE9BQU8sNkJBQTZCLENBQUMsVUFBVSxDQUFDO1FBQzlDLENBQUMsQ0FBQyw4QkFBOEIsQ0FBQyxVQUFVLENBQUM7UUFDNUMsQ0FBQyxDQUFDLFVBQWdDLENBQUM7QUFDdkMsQ0FBQztBQUVELE1BQU0sVUFBVSxpQkFBaUIsQ0FBQyxLQUFhO0lBQzdDLE9BQU8sV0FBVyxDQUFDLFFBQVEsQ0FBQyxLQUFtQixDQUFDLENBQUM7QUFDbkQsQ0FBQztBQUVEOzs7R0FHRztBQUNILE1BQU0sVUFBVSxnQkFBZ0IsQ0FBQyxHQUFXO0lBQzFDLE9BQU8sR0FBRyxDQUFDLE9BQU8sQ0FBQyxLQUFLLEVBQUUsR0FBRyxDQUFDLENBQUM7QUFDakMsQ0FBQyJ9